import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WaitingroomState } from './waitingroom.state';

const selectWaitingRoomState = createFeatureSelector<WaitingroomState>('waitingroom');
const isOnCallSelector = (state: WaitingroomState) => state.onCall;
export const getIsOnCallSelector = createSelector(selectWaitingRoomState, isOnCallSelector);
